export const VerificationStatus = {
  PENDING: { value: "Pending", textColor: "text-yellow-400" },
  REJECTED: { value: "Rejected", textColor: "text-red-400" },
  VERIFIED: { value: "Verified", textColor: "text-green-400" },
} as const;
